import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = { class: "h2" }
const _hoisted_3 = { class: "py-3" }
const _hoisted_4 = { class: "py-4 my-0 form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("legend", { "aria-describedby": "configuration" }, null, -1)
const _hoisted_6 = {
  class: "form-label",
  for: "cardboard-input"
}
const _hoisted_7 = { class: "form-group-radio" }
const _hoisted_8 = {
  class: "form-label",
  for: "radiogroup-option1"
}
const _hoisted_9 = { class: "form-group-radio" }
const _hoisted_10 = {
  class: "form-label",
  for: "radiogroup-option2"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hasAccess)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h1", _hoisted_2, [
                _createVNode(_component_SimpleText, { "text-key": "configuration.title" })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", {
                  id: "configuration",
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("fieldset", null, [
                      _hoisted_5,
                      _createElementVNode("label", _hoisted_6, [
                        _createVNode(_component_SimpleText, { "text-key": "configuration.cardboard.button.name" })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "radiogroup-option1",
                          name: "cardboard-input",
                          class: "form-radio radio-large",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardboard) = $event)),
                          value: "false"
                        }, null, 512), [
                          [_vModelRadio, _ctx.cardboard]
                        ]),
                        _createElementVNode("label", _hoisted_8, [
                          _createVNode(_component_SimpleText, { "text-key": "configuration.cardboard.button.off" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "radiogroup-option2",
                          name: "cardboard-input",
                          class: "form-radio radio-large",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardboard) = $event)),
                          value: "true"
                        }, null, 512), [
                          [_vModelRadio, _ctx.cardboard]
                        ]),
                        _createElementVNode("label", _hoisted_10, [
                          _createVNode(_component_SimpleText, { "text-key": "configuration.cardboard.button.on" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    id: "submit-button",
                    class: "button button-primary px-8 my-4 saveButton",
                    type: "submit",
                    disabled: _ctx.submitButtonDisabled
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "configuration.button.submit.name" })
                  ], 8, _hoisted_11)
                ], 32)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}